import { useState } from "react";

const BtnCopy = ({ idCopy }) => {
    const handleCopy = async () => {
        const el = document.getElementById(idCopy);
        if (!el) return;

        const esMovil = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent);

        try {
            if (!esMovil && window.ClipboardItem && navigator.clipboard.write) {
                // En PC, intenta copiar como texto y HTML enriquecido
                const data = new ClipboardItem({
                    "text/plain": new Blob([el.innerText], { type: "text/plain" }),
                    "text/html": new Blob([el.outerHTML], { type: "text/html" }),
                });
                await navigator.clipboard.write([data]);
            } else if (navigator.clipboard && navigator.clipboard.writeText) {
                // En móviles, solo texto plano
                await navigator.clipboard.writeText(el.innerText);
            } else {
                throw new Error("Clipboard API no disponible.");
            }

            // Feedback visual (opcional)
            el.style.opacity = "0.4";
            setTimeout(() => {
                el.style.opacity = "1";
            }, 100);
        } catch (error) {
            console.error("Error al copiar:", error);
            alert("No se pudo copiar el contenido. Este navegador podría no ser compatible.");
        }
    };

    return (
        <div className="float-right">
            <button
                className="btn btn-outline-secondary btn-xs"
                onClick={(e) => {
                    e.preventDefault();
                    handleCopy();
                }}
            >
                <i className="far fa-copy"></i> Copiar
            </button>
        </div>
    );
};

export default BtnCopy;
